import React from "react";
import { GoogleMap, LoadScript, MarkerF } from "@react-google-maps/api";
const CustomGoogleMapWithMarker = () => {
  const containerStyle = {
    width: "100%",
    height: "100%",
  };

  const center = {
    lat: 39.942064,
    lng: 32.855603,
  };
  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        Marker
        center={center}
        zoom={15}
      >
        <MarkerF position={{ lat: 39.942064, lng: 32.855603 }} />
       
      </GoogleMap>
    </LoadScript>
  );
};

export default CustomGoogleMapWithMarker;
